import { useTranslation } from "react-i18next";
import { Quote, FileText, Target, Users } from "lucide-react";

const testimonials = [
  { quoteKey: "testimonial1.quote", roleKey: "testimonial1.role" },
  { quoteKey: "testimonial2.quote", roleKey: "testimonial2.role" },
  { quoteKey: "testimonial3.quote", roleKey: "testimonial3.role" },
];

const metrics = [
  { key: "metrics.memorandums", icon: FileText },
  { key: "metrics.access", icon: Target },
  { key: "metrics.teams", icon: Users },
];

export default function TestimonialsSection() {
  const { t } = useTranslation();

  return (
    <section
      className="py-24 md:py-32"
      style={{ backgroundColor: "var(--landing-bg)" }}
    >
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-20">
          <h2
            className="text-3xl md:text-4xl font-bold mb-4"
            style={{ color: "var(--landing-text)" }}
          >
            {t("testimonials.title")}
          </h2>
          <p
            className="text-lg leading-relaxed"
            style={{ color: "var(--landing-text-secondary)" }}
          >
            {t("testimonials.subtitle")}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-20">
          {testimonials.map(({ quoteKey, roleKey }) => (
            <div
              key={quoteKey}
              className="landing-card p-6 rounded-2xl"
            >
              <Quote
                className="h-8 w-8 mb-4"
                style={{ color: "var(--landing-accent)" }}
              />
              <p
                className="leading-relaxed mb-4 text-[15px]"
                style={{ color: "var(--landing-text-secondary)" }}
              >
                &ldquo;{t(quoteKey)}&rdquo;
              </p>
              <p
                className="text-sm font-semibold"
                style={{ color: "var(--landing-primary)" }}
              >
                — {t(roleKey)}
              </p>
            </div>
          ))}
        </div>

        <div className="grid sm:grid-cols-3 gap-6">
          {metrics.map(({ key, icon: Icon }) => (
            <div
              key={key}
              className="flex items-center gap-4 p-6 rounded-xl border border-[var(--landing-border)]"
              style={{
                backgroundColor: "var(--landing-surface)",
                boxShadow: "var(--landing-shadow)",
              }}
            >
              <div
                className="flex items-center justify-center w-12 h-12 rounded-xl shrink-0"
                style={{ backgroundColor: "var(--landing-surface-alt)" }}
              >
                <Icon className="h-6 w-6" style={{ color: "var(--landing-primary)" }} />
              </div>
              <span
                className="font-medium"
                style={{ color: "var(--landing-text)" }}
              >
                {t(key)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
